import { Component, Input, OnInit } from '@angular/core';
import { scales } from 'chart.js';
import { Interaction } from 'src/app/modules/entities/interaction';
import { Person } from 'src/app/modules/entities/person';

interface EventItem {
  status?: string;
  date?: Date;
  icon?: string;
  color?: string;
  image?: string;
}

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {
  events: EventItem[] = [];
  interactionText: { [key: string]: string } = { 'profile_view': 'Vista perfil', 'whatsapp': 'Intento Whatsapp', 'phone': 'Intento llamada' };
  interactionIcon: { [key: string]: string } = { 'profile_view': 'pi pi-user', 'whatsapp': 'pi pi-whatsapp', 'phone': 'pi pi-phone' };
  interactionColor: { [key: string]: string } = { 'profile_view': '#ed1c23', 'whatsapp': '#25d366', 'phone': '#003ea1' };
  @Input() person: Person | undefined;
  @Input() interactions: Interaction[] | undefined = undefined;
  data: any;
  options: any;

  ngOnInit(): void {
    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: '#000000'
          }
        }
      },
      scales: {
        left: {
          position: 'left'
        },
        right: {
          position: 'right'
        }
      }
    };
    let controlDate = new Date(this.person?.user.registrationDate!);
    controlDate.setHours(0,0,0);
    let labels: string[] = [];
    let interactionsByDate: {[key: string]: {[key: string]: number}} = {'profile_view': {}, 'phone': {}, 'whatsapp': {}};
    while (controlDate <= new Date()) {
      labels.push(controlDate.toISOString().slice(0, 10));
      interactionsByDate['profile_view'][controlDate.toISOString().slice(0, 10)] = 0;
      interactionsByDate['phone'][controlDate.toISOString().slice(0, 10)] = 0;
      interactionsByDate['whatsapp'][controlDate.toISOString().slice(0, 10)] = 0;
      controlDate.setDate(controlDate.getDate() + 1);
    }
    for (let interaction of this.interactions!) {
      interactionsByDate[interaction.type][String(interaction.interactionDate).slice(0, 10)] = interactionsByDate[interaction.type][String(interaction.interactionDate).slice(0, 10)] + 1;
    }
    let valuesByType: {[key: string]: number[]} = {'profile_view': [], 'phone': [], 'whatsapp': []};
    controlDate = new Date(this.person?.user.registrationDate!);
    while (controlDate <= new Date()) {
      valuesByType['profile_view'].push(interactionsByDate['profile_view'][controlDate.toISOString().slice(0, 10)]);
      valuesByType['phone'].push(interactionsByDate['phone'][controlDate.toISOString().slice(0, 10)]);
      valuesByType['whatsapp'].push(interactionsByDate['whatsapp'][controlDate.toISOString().slice(0, 10)]);
      controlDate.setDate(controlDate.getDate() + 1);
    }
    //registro
    this.data =
    {
      labels: labels,
      datasets: [
        {
          label: 'Visitas al perfil',
          fill: false,
          borderColor: '#ed1c23',
          backgroundColor: '#ed1c23',
          tension: 0.4,
          data: valuesByType['profile_view'],
          yAxisID: 'left'
        },
        {
          type: 'bar',
          label: 'Intentos de llamada',
          pointStyle: false,
          fill: false,
          borderColor: '#003ea1',
          backgroundColor: '#003ea1',
          tension: 0.4,
          data: valuesByType['phone'],
          yAxisID: 'right'
        },
        {
          type: 'bar',
          label: 'Intentos de contacto en WhatsApp',
          pointStyle: false,
          fill: false,
          borderColor: '#25d366',
          backgroundColor: '#25d366',
          tension: 0.4,
          data: valuesByType['whatsapp'],
          yAxisID: 'right'
        }
      ]
    };
    /*this.events.push({
      status: 'Registro',
      date: this.person?.user.registrationDate,
      icon: 'pi pi-star',
      color: '#e4af00'
    });
    for (let interaction of this.interactions!) {
      this.events.push({
        status: this.interactionText[interaction.type],
        date: interaction.interactionDate,
        icon: this.interactionIcon[interaction.type],
        color: this.interactionColor[interaction.type]
      });
    }*/
  }
}
